import React, { useState } from 'react';
import { usePxToVw } from '../../../hooks/usePxToVw';
const SplashTextAIHuman = ({ text, settings }) => {
  const { pxToVw } = usePxToVw();
  const [isHovered, setIsHovered] = useState(false);


  const style = {
    // Dimensions and layout
    // height: pxToVw(settings?.height), // Button height
    width: '100%', // Button width
    textAlign: 'center', // Text alignment

    // Font and colors
    color:  settings?.brandColor, // Font color
    fontFamily: settings?.brandFont, // Font family
    fontSize: pxToVw(settings?.fontSize), // Font size

    // Text shadow
    // textShadow: `${offsetX}px ${offsetY}px ${settings?.shadow?.size}px rgba(
    //   ${parseInt(settings?.shadow?.color.slice(1, 3), 16)}, 
    //   ${parseInt(settings?.shadow?.color.slice(3, 5), 16)}, 
    //   ${parseInt(settings?.shadow?.color.slice(5, 7), 16)}, 
    //   ${settings?.shadow?.alpha}
    // )`, // Dynamic shadow for text

    // WebkitTextStroke: `${settings?.outlineThickness || 1}px ${settings?.outlineColor || '#000'}`,

    // Transition
    transition: '0.2s ease-in-out', // Smooth animation

    // Cursor style
    cursor: 'pointer',
  };

  return (
    <h3
      style={style}
      onMouseOver={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {text}
    </h3>
  );
};

export default SplashTextAIHuman;
